import { pipe } from 'fp-ts/function'
import * as TE from 'fp-ts/TaskEither'
import { isRight, toError } from 'fp-ts/lib/Either'

interface SubQueryResult<T> {
  data: T
}

export async function runSubqlQuery<T>(
  endpoint: string,
  query: string,
  variables: object = {}
) {
  const resp = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      operationName: null,
      query,
      variables,
    }),
  })
  if (resp.status !== 200) {
    throw new Error(`Subql request failed: ${resp.status}`)
  }
  const data: T = await resp.json()
  return data
}

export function safeRunSubqlQuery<T>(
  endpoint: string,
  query: string,
  variables: object = {}
) {
  return pipe(
    TE.tryCatch<Error, SubQueryResult<T>>(
      () => runSubqlQuery(endpoint, query, variables),
      toError
    ),
    TE.map(i => i.data),
  )
}